import { createApi } from "@reduxjs/toolkit/query/react";
import { reshape_response, buildFiltersUrl } from "helpers/functions";
import customFetchBase from "services/principal/customFetchBase";

export const entidadFederativaApi = createApi({
  reducerPath: "entidadFederativaApi",
  baseQuery: customFetchBase,
  tagTypes: ["EntidadFederativa"],
  endpoints: (builder) => ({
    getEntidadesFederativas: builder.query({
      query: ({ filter_params } = {}) => ({
        url: buildFiltersUrl("/v1/api/entidadfederativa/", filter_params),
        method: "GET",
      }),
      providesTags: (result) =>
        Array.isArray(result)
          ? [
              ...result.map(({ id }) => ({
                type: "EntidadFederativa",
                id,
              })),
              { type: "EntidadFederativa", id: "LIST" },
            ]
          : [{ type: "EntidadFederativa", id: "LIST" }],
      transformResponse: (response, meta, args) => {
        if (Array.isArray(response)) {
          return response?.map((el) => reshape_response(el, args?.shape));
        } else {
          const resultsTransformed = response?.results?.map((el) =>
            reshape_response(el, args?.shape),
          );

          // Devolvemos los resultados transformados junto con las propiedades de paginación
          return {
            results: resultsTransformed,
            count: response.count,
            next: response.next,
            previous: response.previous,
          };
        }
      },
    }),
  }),
});

export const { useGetEntidadesFederativasQuery } = entidadFederativaApi;
